import type { MemberProposal } from '@/types';
import { api } from './api';

const PROPOSAL_REGEX = /<MEMBER_PROPOSAL>\s*([\s\S]*?)\s*<\/MEMBER_PROPOSAL>/;

export async function deriveAppearanceDescription(
  _apiKey: string,
  name: string,
  role: string,
  description: string,
): Promise<string> {
  const result = await api.ai.deriveAppearance(name, role, description);
  return result.description;
}

export function extractMemberProposal(content: string): MemberProposal | null {
  const match = content.match(PROPOSAL_REGEX);
  if (!match) return null;
  try {
    const proposal = JSON.parse(match[1]) as MemberProposal;
    if (!proposal.appearanceDescription) {
      proposal.appearanceDescription = `${proposal.role}. ${proposal.description}`.slice(0, 300);
    }
    return proposal;
  } catch {
    return null;
  }
}

export function cleanMessageContent(content: string): string {
  return content.replace(PROPOSAL_REGEX, '').trim();
}

export async function streamDiscoveryChat(
  _apiKey: string,
  messages: Array<{ role: 'user' | 'assistant'; content: string }>,
  onChunk: (chunk: string) => void,
  onComplete: (fullText: string) => void,
  onError: (error: Error) => void,
  intent: 'discovery' | 'team-consult' | 'member-consult',
  params?: { memberId?: string },
): Promise<void> {
  let fullText = '';

  try {
    for await (const event of api.ai.stream(messages, { intent, params })) {
      if (event.type === 'text_delta') {
        fullText += event.text;
        const visibleSoFar = cleanMessageContent(fullText);
        onChunk(visibleSoFar);
      } else if (event.type === 'error') {
        throw new Error(event.message);
      }
    }
    onComplete(fullText);
  } catch (err) {
    onError(err instanceof Error ? err : new Error(String(err)));
  }
}
